import React, { useEffect, useState, useContext } from "react";
import UserContext from "../context/UserContext";
import { api } from "../utils/apiHelper";
import "../styles/specialMan.css";

const SpecialProdManager = () => {
  const { authUser } = useContext(UserContext);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await api("/special-products");

        if (Array.isArray(response)) {
          setProducts(response);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

   if (!authUser || authUser.email !== "support@editfarmer.com") {
    return null;
  }


  const deleteProduct = async (productId) => {
    if (!window.confirm("Delete this product?")) return;

    const response = await api(`/special-product/${productId}`, "DELETE");

    if (response?.success) {
      setProducts(products.filter(p => p.productId !== productId));
    }
  };

  const toggleActive = async (productId, active) => {
    const response = await api(`/special-product/${productId}`, "PUT", {
      active: !active,
    });

    if (response?.success) {
      setProducts(products.map(product =>
        product.productId === productId
          ? { ...product, active: !active }
          : product
      ));
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="special-manager-container">
      <h2>Special Products</h2>

      {products.length === 0 ? (
        <p>No products found.</p>
      ) : (
        products.map(product => (
          <div
            key={product.productId}
            className="special-manager-card"
          >
         
 {product.image?.url && (
  <img
    src={product.image.url}
    alt={product.title}
    className="special-manager-image"
  />
)}

            <div className="special-manager-info">
              <h3>{product.title}</h3>

              <p>{product.description}</p>

              <p>
                <strong>Prices:</strong>{" "}
                {product.priceOptions?.join(", ")}
              </p>

              <p>
                <strong>Status:</strong>{" "}
                {product.active ? "Active" : "Inactive"}
              </p>

              <div className="special-manager-buttons">
                <button
                  onClick={() =>
                    toggleActive(
                      product.productId,
                      product.active
                    )
                  }
                >
                  {product.active
                    ? "Deactivate"
                    : "Activate"}
                </button>

                <button
                  onClick={() =>
                    deleteProduct(product.productId)
                  }
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default SpecialProdManager;